import classNames from 'classnames/bind';
import React, { useState } from 'react';

import VideoStream from './01_VideoStream';
import Ntrip from './02_Ntrip';
import styles from './index.module.scss';

import { PrimaryButton } from '@/components/ui/kit/Button';
import ModalWrapper from '@/components/ui/ModalWrapper';
import { modalManager } from '@/libs/ModalContainer';

const cx = classNames.bind(styles);

const Modal = ({ robot }) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const selectTab = (e) => {
    setActiveTabIndex(Number(e.target.dataset.index));
  };

  const close = () => {
    modalManager.hide();
  };

  return (
    <ModalWrapper className={cx('container')}>
      <div className={cx('content')}>
        <div className={cx('tabs')}>
          <div data-index="0" className={cx(['tab', { active: activeTabIndex === 0 }])} onClick={selectTab}>
            Video Stream
          </div>
          <div data-index="1" className={cx(['tab', { active: activeTabIndex === 1 }])} onClick={selectTab}>
            NTRIP
          </div>
        </div>
        <div className={cx('pane')}>
          {activeTabIndex === 0 && <VideoStream robot={robot} />}
          {activeTabIndex === 1 && <Ntrip robot={robot} />}
        </div>
      </div>
      <PrimaryButton text="Close" center onClick={close} />
    </ModalWrapper>
  );
};

export default Modal;
